import videojs from 'video.js';
import { composeUI } from '../compose-ui';

const defaults = {
	radius: 24
};

export default class SvgClip extends videojs.getPlugin('plugin') {
	constructor(player, options) {
		super(player, options);
		this.options = videojs.mergeOptions(defaults, options);
		composeUI(player);
		player.on('ready', () => this.setListeners());
	}

	setListeners() {
		this.player.on(['play', 'playerresize', 'ended'], event => {
			const { viewMode, videoOrientation } = this.player.el().dataset;
			viewMode === 'desktop' && videoOrientation === 'portrait' && this.player.hasClass('vjs-has-started')
				? this.setPath()
				: this.resetPath();
			if (event.type === 'ended') {
				this.resetPath();
			}
		});
	}

	setPath() {
		const { offsetLeft, clientWidth, clientHeight } = this.player.el();
		const {radius} = this.options;
		this.player.el().style.clipPath = `path('M-${offsetLeft},0 v${radius} h${offsetLeft} q0,-${radius} ${radius},-${radius} h${clientWidth - radius * 2} q${radius},0 ${radius},${radius} h${offsetLeft} v${clientHeight - 2 * radius} h-${offsetLeft} q0,${radius} -${radius},${radius} h-${clientWidth - radius * 2} q-${radius},0 -${radius},-${radius} h-${offsetLeft} z')`;
	}

	resetPath() {
		this.player.el().style.clipPath = '';
	}
}

videojs.registerPlugin('svgClip', SvgClip);
